export const recommendationToUserHistoryData = [
  {
    id: 1,
    userId: 1,
    recommendationName: 'Medication, Avoid',
    matchedConditions: [
      {
        variable: 'Weight',
        operator: 'Greater Than',
        answer: 0,
        userAnswer: 100,
      },
    ],
    startedAt: '2021-01-02T10:23:45Z',
    endedAt: null,
  },
  {
    id: 2,
    userId: 1,
    recommendationName: 'Medication, Caution',
    matchedConditions: [
      {
        variable: 'Height',
        operator: 'Greater Than',
        answer: 0,
        userAnswer: 100,
      },
    ],
    startedAt: '2021-02-02T10:23:46Z',
    endedAt: '2021-03-02T10:23:47Z',
  },
  {
    id: 3,
    userId: 1,
    recommendationName: 'Medication, Consider',
    matchedConditions: [
      {
        variable: 'BMI',
        operator: 'Greater Than',
        answer: 0,
        userAnswer: 100,
      },
    ],
    startedAt: '2021-04-02T10:23:48Z',
    endedAt: '2021-05-02T10:23:49Z',
  },
];
